module.exports = __webpack_public_path__ + "img/GS_Profile-Katlego Masiangwako.fff599a1.png";